import { getColor } from './../../../src/styled/utils/index';
import { getSizeBy } from '../../../src/styled/utils';
import styled from 'styled-components';
export const Block = styled.div `
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  height: 100%;
  padding: ${getSizeBy(3)} ${getSizeBy(4)};
  background-color: ${getColor('surface')};
`;
export const Centered = styled(Block) `
  display: flex;
  gap: ${getSizeBy(2)};
  align-items: center;
  justify-content: center;
`;
export const StyledText = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${getSizeBy(1)};
  width: 80%;
  text-align: center;
`;
